import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import theme from '~/truck/theme'

export const Image = styled.img`
  margin-bottom: ${theme.spacing.comfortable}px;
  object-fit: cover;
  width: 100%;

  ${up('lg')} {
    max-height: ${theme.spacing.cozy * 60}px;
  }
`

export const Content = styled.div`
  display: grid;
  grid-row-gap: ${theme.spacing.relaxed}px;
`

export const Container = styled.div`
  width: 100%;
`
